import { createContext, useContext, useEffect, useState } from "react";

const THEME_KEY = "mds-theme";
const ThemeContext = createContext({ theme: "light", setTheme: () => {} });

function getInitialTheme() {
  const stored =
    typeof window !== "undefined" && window.localStorage.getItem(THEME_KEY);
  if (stored === "light" || stored === "dark") return stored;
  if (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  )
    return "dark";
  return "light";
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getInitialTheme);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("mds-theme-dark");
      root.setAttribute("data-theme", "dark");
    } else {
      root.classList.remove("mds-theme-dark");
      root.setAttribute("data-theme", "light");
    }
    try {
      window.localStorage.setItem(THEME_KEY, theme);
    } catch (_) {}
  }, [theme]);

  const setTheme = (next) => {
    setThemeState(next === "dark" ? "dark" : "light");
  };

  const toggleTheme = () => {
    setThemeState((t) => (t === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
